export default __webpack_public_path__ + "static/media/Slider_500_Web.5eccabb6.png";